"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutYesChefJess() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-yes-chef-jess" className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {}
          <div ref={leftRef} className={`relative transition-all duration-[200ms] ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative w-full aspect-[3/4] max-w-md mx-auto">
              {}
              <div className="w-full h-full bg-cover bg-center shadow-medium" style={{
              clipPath: "ellipse(45% 48% at 50% 50%) polygon(50% 0%, 61% 15%, 75% 25%, 90% 40%, 95% 60%, 90% 80%, 75% 90%, 60% 95%, 50% 100%, 40% 95%, 25% 90%, 10% 80%, 5% 60%, 10% 40%, 25% 25%, 39% 15%)",
              backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1509250/img/chef_jess_portrait.png)"
            }} />
              {}
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-secondary/20 rounded-full blur-xl" aria-hidden="true" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/15 rounded-full blur-2xl" aria-hidden="true" />
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-[200ms] ease-out delay-100 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative bg-muted-light-background rounded-lg p-8 md:p-10 shadow-soft">
              {}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-secondary to-accent rounded-t-lg" style={{
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 95% 80%, 85% 60%, 75% 50%, 60% 45%, 40% 50%, 25% 60%, 10% 80%, 5% 90%, 0 100%)"
            }} />

              <div className="space-y-6">
                <h2 className="text-3xl md:text-4xl font-display text-foreground leading-tight">
                  About Chef Jess
                </h2>

                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    Based in the vibrant culinary scene of Los Angeles, Chef
                    Jess brings together passion, technique, and community
                    through two unique experiences: <strong>Pass the Plate</strong> and{" "}
                    <strong>Create the Plate</strong>.
                  </p>

                  <p>
                    <strong>Pass the Plate</strong> is an intimate monthly
                    supper club where curated menus change with the seasons,
                    bringing people together over shared moments and memorable
                    food. Each dinner is a celebration of connection and
                    creativity.
                  </p>

                  <p>
                    <strong>Create the Plate</strong> offers hands-on cooking
                    classes designed to demystify cooking techniques and make
                    the art of cooking approachable, fun, and deeply personal.
                    Every class is small, ensuring personalized instruction
                    every step of the way.
                  </p>

                  <p className="text-foreground font-semibold italic">
                    Join Chef Jess in creating community, education, and
                    unforgettable culinary experiences.
                  </p>
                </div>

                <div className="pt-4">
                  <Button asChild className="transition-transform duration-[120ms] ease-in-out hover:scale-104 shadow-soft hover:shadow-medium">
                    <Link to="#services">Explore Our Services</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}